<template>
  <v-card
      class="mx-auto image-box"
      :max-width="maxWidth"
      v-if="memeData"
  >
    <v-img
        class=" white--text align-end"
        max-height="475"
        :src="memeData.url"
        contain

    >

    </v-img>

    <v-card-actions>
      <PotentialMemeVoter v-on="$listeners"/>
    </v-card-actions>

  </v-card>
</template>

<script>
import PotentialMemeVoter from "@/components/meme-voting/PotentialMemeVoter";
export default {
  name: "PotentialMeme",
  components: {PotentialMemeVoter},
  props: {
    memeData: Object
  },
  computed: {
    maxWidth () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return 350
        case 'sm': return 350
        case 'md': return 500
        case 'lg': return 500
        case 'xl': return 500
        default: return 400
      }
    },
  }
}
</script>

<style scoped>

</style>